import axios from "axios";
import { toast } from "react-toastify";
import { Spinner, Badge, Modal, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "providers/appProvider";
import { getExampleNumber } from 'libphonenumber-js';
import metadata from 'libphonenumber-js/metadata.full.json';
import loginPageImg from 'assets/img/generic/loginBg.jpg';
import logoFallback from 'assets/img/logoImage.jpeg';
import Cookies from 'js-cookie';
import paths from '../../routes/paths';
import SubtleBadge from "components/common/subtleBadge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FalconCloseButton from "components/common/falconCloseButton";
import moment from "moment";
import { io } from 'socket.io-client';
import i18n from 'culture/i18n';
import { getOccurrenceCount } from "utils/recurrenceHelpers";

export function formatDate(dateString) {
  if (!dateString) return "--";
  const date = new Date(dateString);

  if (isNaN(date.getTime())) return "--";
  return new Intl.DateTimeFormat('nl-NL', {
    day: '2-digit',
    month: '2-digit',  // Include the month formatting as well
    year: 'numeric'
  }).format(date);
}

export function formatTime(timeString) {
  if (!timeString) return "--";

  const date = new Date(timeString);
  if (isNaN(date.getTime())) return "--";

  return date.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  });
}

let rolesRequestPromise = null;

export const fetchAllRoles = async () => {
  if (!rolesRequestPromise) {
    rolesRequestPromise = axios
      .get(`${process.env.REACT_APP_API_URL}/roleRoute/roles`, {
        headers: {
          Authorization: process.env.REACT_APP_BasicAuthSecret
        }
      })
      .then((res) => res.data)
      .catch((error) => {
        rolesRequestPromise = null; 
        console.error("Error fetching roles:", error);
        throw new Error("Unable to fetch roles");
      });
  }
  return rolesRequestPromise;
};

export const fetchRoleMappings = async (roleId, t) => {
  const roleTranslations = {
    "App Owner": t("appOwnerText"),
    "Admin": t("adminText"),
    "Client": t("clientText"),
    "Employee": t("employeeText"),
  };

  try {
    const roles = await fetchAllRoles();
    const rolesMap = roles.reduce((map, role) => {
      map[role.RoleId] = roleTranslations[role.Name] || role.Name;
      return map;
    }, {});

    return rolesMap[roleId] || "Unknown";
  } catch (error) {
    console.error("Error fetching role mappings:", error);
    throw new Error("Unable to fetch role mappings");
  }
};

export const fetchRoleAndClaims = async ({
  navigate,
  claimType,
  claimValue,
  setHasAccess,
  setIsLoading,
  t
}) => {
  const userId = localStorage.getItem("UserId");
  const roleName = localStorage.getItem("UserRole");
  const isEmployeeView = sessionStorage.getItem("isEmployeeView");

  const redirectToDashboard = () => {
    const target =
      roleName === "Employee" || isEmployeeView === "true"
        ? "/employee/dashboard"
        : "/dashboard";

    if (window.location.pathname === target) return;
    navigate(target);
  };

  if (!userId || !roleName) {
    disconnectSocket();
    localStorage.clear();
    sessionStorage.clear();
    toast.error("userSessionIncomplete");
    navigate(paths.login, { replace: true });
    return;
  }

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/userRoute/checkPermission/${userId}`,
      {
        params: { claimType, claimValue },
        headers: { Authorization: process.env.REACT_APP_BasicAuthSecret }
      }
    );

    if (response.data.hasPermission) {
      setHasAccess(true);
    } else {
      redirectToDashboard();
    }
  } catch (error) {
    const translate = typeof t === "function" ? t : i18n.t.bind(i18n);
    toast.error(translate("permissionValidationError"), { toastId: "permission-validation-error" });
    if (error.response) {
      redirectToDashboard();
    }
  } finally {
    setIsLoading(false);
  }
};

export const fetchFilteredUsers = (users, roles) => {

  const clientRoleDetails = roles.filter(role =>
    role.Name == "Client"
  );
  const usersWithdFilteredRoles = users.filter(user =>
    user.Role !== clientRoleDetails[0].RoleId
  );
  return usersWithdFilteredRoles;
};

export const handleLoadingAndAccess = (isLoading, hasAccess) => {
  if (isLoading) {
    return (
      <div className="text-center p-4">
        <Spinner animation="border" role="status" />
      </div>
    );
  }
  if (!hasAccess) {
    return null;
  }
  return null; // Default return if no conditions are met
};

export const generateRelationNumber = async () => {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0"); // Day padded with zero
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Month padded with zero
  const year = String(now.getFullYear()).slice(-2); // Last two digits of the year
  const hour = String(now.getHours()).padStart(2, "0"); // Hour padded with zero
  const second = String(now.getSeconds()).padStart(2, "0"); // Seconds padded with zero
  const milli = String(now.getMilliseconds()).padStart(3, "0"); // Full milliseconds (000-999)

  return `KL${day}${month}${year}${hour}${second}${milli}`; // Constructed relation number
};

export const generateGUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

//asperion methods
export const createAuthorizationUrl = () => {
  const client_id = process.env.REACT_APP_CLIENT_ID;
  const redirect_uri = process.env.REACT_APP_REDIRECT_URI;
  return `${process.env.REACT_APP_ASPERION_IDENTITY_SERVER_URL}/connect/authorize?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=code&scope=asperion-api offline_access`;
};

export const openPopup = (authorizationUrl) => {
  const popupWidth = 600;
  const popupHeight = 800;
  const screenLeft = window.screenLeft || window.screenX;
  const screenTop = window.screenTop || window.screenY;
  const screenWidth = window.innerWidth || document.documentElement.clientWidth || screen.width;
  const screenHeight = window.innerHeight || document.documentElement.clientHeight || screen.height;
  const left = screenLeft + (screenWidth - popupWidth) / 2;
  const top = screenTop + (screenHeight - popupHeight) / 2;

  return window.open(
    authorizationUrl,
    "LoginPopup",
    `width=${popupWidth},height=${popupHeight},top=${top},left=${left}`
  );
};

export const getAuthorizationCode = (popup) => {
  const redirect_uri = process.env.REACT_APP_REDIRECT_URI;

  return new Promise((resolve, reject) => {
    const checkPopup = setInterval(() => {
      try {
        if (!popup || popup.closed) {
          clearInterval(checkPopup);
          reject(new Error("Popup was closed before completing the login process."));
          return;
        }

        // Ensure we can access the popup's location (avoiding cross-origin errors)
        let popupUrl;
        try {
          popupUrl = popup.location.href;
        } catch (err) {
          console.warn("Waiting for popup to redirect to the correct origin...");
          return; // Skip this loop iteration until we can access the URL
        }

        // Check if the popup has been redirected to our callback URL
        if (popupUrl.includes(redirect_uri)) {
          const urlParams = new URLSearchParams(popup.location.search);
          const authorizationCode = urlParams.get("code");

          if (authorizationCode) {
            clearInterval(checkPopup);
            popup.close();
            resolve(authorizationCode);
          }
        }
      } catch (error) {
        console.error("Error in getAuthorizationCode:", error);
      }
    }, 500);
  });
};

export const exchangeCodeForToken = async (authorizationCode) => {
  // const tokenResponse = await axios.post(
  //   `${process.env.REACT_APP_API_URL}/asperionTokenRoute/exchangeCodeForToken/${authorizationCode}`,
  //   authorizationCode
  // );
  // return tokenResponse.data;

  const tokenResponse = await axios.post(
    `${process.env.REACT_APP_API_URL}/asperionAutoTokenRoute/exchangeCodeForToken/${authorizationCode}`,
    authorizationCode, {
    headers: {
      Authorization: process.env.REACT_APP_BasicAuthSecret
    }
  }
  );
  return tokenResponse.data;
};

export const updateAsperionToken = async (tokenDataBody) => {
  // await axios.post(
  //   `${process.env.REACT_APP_API_URL}/asperionTokenRoute/addUpdateAsperionToken`,
  //   tokenDataBody
  // );
  await axios.post(
    `${process.env.REACT_APP_API_URL}/asperionAutoTokenRoute/saveToken`,
    tokenDataBody, {
    headers: {
      Authorization: process.env.REACT_APP_BasicAuthSecret
    }
  }
  );
};

export const handleCreateAsperionRelationConfirmationMessgae = (setIsLoading, message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 5000,
  });
  setIsLoading(false)
}

export const handleUpdateAsperionRelationConfirmationMessgae = (setIsLoading, message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 5000,
  });
  setIsLoading(false)
}

export const useLocationRedirect = (path) => {
  const { config } = useAppContext();
  const navigate = useNavigate();
  const [prevLocationId, setPrevLocationId] = useState(null);

  useEffect(() => {
    const initialLocationId = localStorage.getItem("LocationId") || config.location?.LocationId;
    setPrevLocationId(initialLocationId);
  }, []);

  useEffect(() => {
    if (config.location?.LocationId) {
      if (prevLocationId && prevLocationId !== config.location?.LocationId) {
        navigate(`/${path}`); // Navigate if IDs differ
      }
      setPrevLocationId(config.location?.LocationId);
    }
  }, [config.location]);
};

export const fetchProposalDocumentDetails = async (proposalDetailId, setProposalDocumentDetail) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/proposalDetailsRoute/getProposalDetailsById/${proposalDetailId}`, {
      headers: {
        Authorization: process.env.REACT_APP_BasicAuthSecret
      }
    }
    );
    setProposalDocumentDetail(response.data);
  } catch (error) {
    console.error("Error fetching proposal document details:", error);
  }
};

export const handleSendProposal = async (proposalDocumentDetail, formData, relationData, t, setIsEmailButtonDisabled, handleCloseProposal, domain) => {
  try {
    const userId = localStorage.getItem("UserId");
    const customerId = localStorage.getItem("customerId");
    setIsEmailButtonDisabled(true);
    let emailData = {
      ...proposalDocumentDetail,
      culture: localStorage.getItem("culture"),
      // LocationAddress: `${formData.locationData.StreetName} ${formData.locationData.HouseNumber}`,
      // LocationTown: `${formData.locationData.PostCode} ${formData.locationData.City}`,
      LocationAddress: `${(formData.locationData || formData.locationDetails)?.StreetName || ""} ${(formData.locationData || formData.locationDetails)?.HouseNumber || ""}`,
      LocationTown: `${(formData.locationData || formData.locationDetails)?.PostCode || ""} ${(formData.locationData || formData.locationDetails)?.City || ""}`,
      UserId: userId,
      CustomerId: customerId,
      ClientEmailaddress: relationData?.Emailaddress1, //  use relation's email
      Contactperson: relationData?.Contactperson,
    };

    if (proposalDocumentDetail.ClientEmailaddress !== formData.ClientEmailaddress) {
      emailData = {
        ...emailData,
        ClientEmailaddress: relationData.Emailaddress1,
      };
    }

    const resp = await axios.post(
      `${process.env.REACT_APP_API_URL}/emailRoute/sendProposalEmail`,
      emailData, {
      headers: {
        Authorization: process.env.REACT_APP_BasicAuthSecret
      }
    }
    );

    if (resp.status === 200) {
      toast.success(t("proposalSentSuccess"), {
        position: "top-right",
        autoClose: 5000,
      });
      handleCloseProposal()
    }
  } catch (error) {
    console.error("Error sending proposal email:", error);
    toast.error(t("proposalSentError"), {
      position: "top-right",
      autoClose: 5000,
    });
    handleCloseProposal()
  } finally {
    setIsEmailButtonDisabled(false);
    if (handleCloseProposal) handleCloseProposal();
  }
};

export const getPhoneExample = (countryCode) => {
  try {
    const example = getExampleNumber(countryCode, metadata);
    return example ? example.formatNational() : '000 0000000';
  } catch {
    return '000 0000000';
  }
};

export const formatRecurrence = (recurrence, t) => {
  if (!recurrence?.frequency) return "";

  if (recurrence.frequency === "OneTime") return `(${t("oneTime")})`;

  const key = recurrence.frequency.toLowerCase();
  if (!["daily", "weekly", "monthly", "yearly"].includes(key)) return "";

  return `(${getOccurrenceCount(recurrence)}x ${t(key)})`;
};

export const appendNewTasksToExistingTask = (newTasks, cleaningContent, setCleaningContent, t) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(cleaningContent, 'text/html');

  const strongTag = doc.querySelector('strong');
  const mainUl = strongTag?.nextSibling?.nodeType === 3
    ? strongTag.parentElement.querySelector('ul')
    : strongTag.nextElementSibling?.tagName === 'UL'
      ? strongTag.nextElementSibling
      : null;

  if (!mainUl) return;

  newTasks.forEach(task => {
    const li = doc.createElement('li');
    li.textContent = `${task.label} ${formatRecurrence(task.recurrence, t)}`;


    if (task.Subtasks?.length) {
      const subUl = doc.createElement('ul');
      task.Subtasks.forEach(sub => {
        const subLi = doc.createElement('li');
        subLi.textContent = sub.Subtask;
        subUl.appendChild(subLi);
      });
      li.appendChild(subUl);
    }

    mainUl.appendChild(li);
  });

  const updatedContent = doc.body.innerHTML;
  setCleaningContent(updatedContent);
};

export const generateTaskHtml = (
  proposalTaskData = [],
  task = [],
  subtasksMap = {},
  selectedSubtasks = [],
  t,
  templateName
) => {
  if (!Array.isArray(proposalTaskData) || proposalTaskData.length === 0) return "";

  const selectedSubtaskMap = {};
  selectedSubtasks.forEach((s) => {
    if (!selectedSubtaskMap[s.taskId]) selectedSubtaskMap[s.taskId] = new Set();
    selectedSubtaskMap[s.taskId].add(s.subtaskId);
  });

  const normalizedName = (templateName || "").toLowerCase();
  const heading = t("workProgramHeading", { name: normalizedName });

  return `
    <strong>${heading}</strong>
    </br>
    ${t("menu.activities")} :
    <ul>
      ${proposalTaskData
      .map((proposalTask) => {
        const parsedDays = (() => {
          try {
            const raw = proposalTask.SelectedDays;
            return typeof raw === "string" ? JSON.parse(raw || "[]") : (raw ?? []);
          } catch {
            return [];
          }
        })();
        const isAdvanced =
          parsedDays && typeof parsedDays === "object" && !Array.isArray(parsedDays);

        const recurrenceText = formatRecurrence(
          {
            frequency: proposalTask.Frequency,
            repeatEvery: proposalTask.RepeatEvery,
            selectedDays: Array.isArray(parsedDays) ? parsedDays : [],
            advancedRecurrence: isAdvanced ? parsedDays : null,
            monthlyDay: proposalTask.MonthlyDay,
          },
          t
        );

        const taskDetail = task.find((t) => t.TaskId === proposalTask.TaskId);
        const taskName = taskDetail?.TaskName || t("unknownTask");

        const taskSubtasks = subtasksMap[proposalTask.TaskId] || [];

        // 🟨 Only include selected subtasks
        const subtasksHtml = taskSubtasks
          .filter((sub, index, subtasks) => {
            const subtaskId = sub.id || sub.SubtaskId || sub.ProposalSubtaskId;
            return selectedSubtaskMap[proposalTask.TaskId]?.has(subtaskId)
              && subtasks.findIndex((item) => (item.id || item.SubtaskId || item.ProposalSubtaskId) === subtaskId) === index;
          })
          .map((sub) => `<li>${sub.name || sub.Subtask || sub.SubtaskName}</li>`)
          .join("");

        return `<li>${taskName} ${recurrenceText}<ul>${subtasksHtml}</ul></li>`;
      })
      .join("")}
    </ul>
  `;
};

export const filterSubtasksMap = (fullMap = {}, selected = []) => {
  const filtered = {};
  const selectedByTask = selected.reduce((map, { taskId, subtaskId }) => {
    if (!map[taskId]) map[taskId] = new Set();
    map[taskId].add(subtaskId);
    return map;
  }, {});
  Object.entries(fullMap).forEach(([taskId, subList]) => {
    const selectedIds = selectedByTask[taskId] || new Set();
    const seen = new Set();
    const ordered = subList.filter((sub) => {
      const subtaskId = sub.id || sub.SubtaskId || sub.ProposalSubtaskId;
      if (!selectedIds.has(subtaskId) || seen.has(subtaskId)) return false;
      seen.add(subtaskId);
      return true;
    });
    if (ordered.length) filtered[taskId] = ordered;
  });
  return filtered;
};

export const fetchGenSettingsUpdated = async (domain) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/settingsRoute/getUpdatedAt/${domain}`, {
      headers: {
        Authorization: process.env.REACT_APP_BasicAuthSecret
      }
    }
    );
    return String(res.data.updatedAt); // or use `.toISOString()` if needed
  } catch (err) {
    console.error("Failed to fetch general settings updatedAt", err);
    return "0";
  }
};

export const fetchLoginImage = async () => {
  const domainToUse = process.env.REACT_APP_DEFAULT_DOMAIN;
  const cacheKey = `cachedLoginBg_${domainToUse}`;
  const versionKey = `genSettingsUpdated_${domainToUse}`;

  const cachedImage = localStorage.getItem(cacheKey);
  const cachedVersion = localStorage.getItem(versionKey);

  if (cachedImage) {
    fetchGenSettingsUpdated(domainToUse).then((serverVersion) => {
      if (serverVersion !== cachedVersion) {
        axios.get(`${process.env.REACT_APP_API_URL}/settingsRoute/getSettingsByDomain/${domainToUse}`, {
          headers: {
            Authorization: process.env.REACT_APP_BasicAuthSecret
          }
        }
        ).then((res) => {
          const base64 = res.data?.LoginPageImage;
          const ext = res.data?.LoginPageImgExtension;
          const updatedAt = res.data?.updatedAt;

          if (base64 && ext && updatedAt) {
            const imageSrc = `data:image/${ext};base64,${base64}`;
            localStorage.setItem(cacheKey, imageSrc);
            localStorage.setItem(versionKey, updatedAt);
          }
        })
          .catch((error) => {
            console.error("Background login image refresh failed", error);
          });
      }
    });

    return cachedImage;
  }

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/settingsRoute/getSettingsByDomain/${domainToUse}`, {
      headers: {
        Authorization: process.env.REACT_APP_BasicAuthSecret
      }
    }
    );

    const base64 = res.data?.LoginPageImage;
    const ext = res.data?.LoginPageImgExtension;
    const updatedAt = res.data?.updatedAt;

    const imageSrc = base64 && ext
      ? `data:image/${ext};base64,${base64}`
      : loginPageImg;

    return new Promise((resolve) => {
      const img = new Image();
      img.src = imageSrc;
      img.onload = () => {
        if (base64 && ext && updatedAt) {
          localStorage.setItem(cacheKey, imageSrc);
          localStorage.setItem(versionKey, updatedAt);
        }
        resolve(imageSrc);
      };
      img.onerror = () => resolve(loginPageImg);
    });
  } catch (error) {
    console.error("Failed to fetch login background image:", error);
    return loginPageImg;
  }
};

export const fetchLogoSrc = async (customerId) => {
  const resolvedCustomerId =
    customerId ||
    sessionStorage.getItem('customerId') ||
    localStorage.getItem('customerId');
  if (!resolvedCustomerId) {
    console.error("CustomerId not provided and not found in localStorage.");
    return logoFallback;
  }

  const domainToUse = process.env.REACT_APP_DEFAULT_DOMAIN;
  const cacheKey = `cachedLogo_${resolvedCustomerId}`;
  const versionKey = `genSettingsUpdated_${domainToUse}`;

  const cachedLogo = localStorage.getItem(cacheKey);
  const cachedVersion = localStorage.getItem(versionKey);

  if (cachedLogo) {
    fetchGenSettingsUpdated(domainToUse).then((serverVersion) => {
      if (serverVersion !== cachedVersion) {
        axios.get(`${process.env.REACT_APP_API_URL}/settingsRoute/getSettingsByCustomer/${resolvedCustomerId}`, {
          headers: {
            Authorization: process.env.REACT_APP_BasicAuthSecret
          }
        }).then((res) => {
          const { LogoImage, LogoImgExtension, updatedAt } = res.data;
          if (LogoImage && LogoImgExtension && updatedAt) {
            const imageSrc = `data:image/${LogoImgExtension};base64,${LogoImage}`;
            localStorage.setItem(cacheKey, imageSrc);
            localStorage.setItem(versionKey, updatedAt);
          }
        })
          .catch((error) => {
            console.error("Background logo refresh failed", error);
          });
      }
    }).catch((error) => console.error("Version check failed", error));

    return cachedLogo;
  }

  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/settingsRoute/getSettingsByCustomer/${resolvedCustomerId}`, {
      headers: {
        Authorization: process.env.REACT_APP_BasicAuthSecret
      }
    }
    );
    const { LogoImage, LogoImgExtension, updatedAt } = res.data;

    if (LogoImage && LogoImgExtension && updatedAt) {
      const imageSrc = `data:image/${LogoImgExtension};base64,${LogoImage}`;
      localStorage.setItem(cacheKey, imageSrc);
      localStorage.setItem(versionKey, updatedAt);
      return imageSrc;
    }
  } catch (error) {
    console.error("Failed to fetch logo:", error);
  }

  return logoFallback;
};

export const getInitialPageSize = (tableKey, validOptions = [25, 50, 75, 100]) => {
  const saved = Number(Cookies.get(`rowsPerPage_${tableKey}`));
  return validOptions.includes(saved) ? saved : validOptions[0];
};

export const toSafeFileName = (name = "") =>
  String(name)
    .replace(/[\\/:*?"<>|]/g, "")     
    .replace(/[\u2013\u2014]/g, "-")   
    .replace(/,/g, "")                 
    .replace(/\s+/g, "-")             
    .replace(/-{2,}/g, "-")            
    .replace(/^-+|-+$/g, "")          
    .trim();

export const buildExportFileName = ({ label = "", from, to }) => {
  const fmt = (d) => moment(d).locale("en").format("YYYY-MM-DD");
  return toSafeFileName(`${label}-${fmt(from)}_to_${fmt(to)}`);
};

export const toSafeSheetName = (name = "", fallback = "Sheet1") =>
  String(name).replace(/[\\/?*[\]:]/g, "").slice(0, 31) || fallback;

export const fetchRelations = async (relationId) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/relationRoute/getRelationById/${relationId}`, {
      headers: {
        Authorization: process.env.REACT_APP_BasicAuthSecret
      }
    }
    );
    return response.data; //  Return data to caller
  } catch (error) {
    console.error("Error fetching relation details:", error);
    return null; // Optional: return null or throw error based on how you want to handle it
  }
};

export const sendEmailToCleaner = async (cleanerEmail, cleanerName, orderInfo, showFrequency = true) => {

  try {
    const customerId = localStorage.getItem("customerId")
    await axios.post(`${process.env.REACT_APP_API_URL}/emailRoute/sendCleanerAssignmentEmail`, {
      to: cleanerEmail,
      cleanerName: cleanerName, // pass from orderInfo
      culture: localStorage.getItem("culture") || "nl",
      orderInfo: orderInfo, // body info (client, tasks, dates, etc.)
      customerId: customerId, // env for logo download
      userId: localStorage.getItem("UserId"), //  userId from localStorage
      organizationName: process.env.REACT_APP_ORGANIZATION_NAME, //  organization name from env
      showFrequency: showFrequency
    },
      {
        headers: {
          Authorization: process.env.REACT_APP_BasicAuthSecret
        }
      }
    );
  } catch (err) {
    console.error("Error sending email to cleaner", err);
  }
};

export const sendUnassignmentEmailToCleaner = async (cleanerEmail, cleanerName, newCleanerName, orderInfo, showFrequency = true) => {
  try {
    const customerId = localStorage.getItem("customerId");
    await axios.post(`${process.env.REACT_APP_API_URL}/emailRoute/sendCleanerUnassignmentEmail`, {
      to: cleanerEmail,
      cleanerName: cleanerName,
      newCleanerName: newCleanerName,
      culture: localStorage.getItem("culture") || "nl",
      orderInfo: orderInfo,
      customerId: customerId,
      userId: localStorage.getItem("UserId"),
      organizationName: process.env.REACT_APP_ORGANIZATION_NAME,
      showFrequency: showFrequency
    },
      {
        headers: {
          Authorization: process.env.REACT_APP_BasicAuthSecret
        }
      }
    );
  } catch (err) {
    console.error("Error sending unassignment email to cleaner", err);
  }
};

export const sendLeaveReassignEmail = async (cleanerEmail, cleanerName, otherEmployeeName, leaveType, startDate, endDate, startTime, endTime, type) => {
    try {
        await axios.post(`${process.env.REACT_APP_API_URL}/emailRoute/sendLeaveReassignEmail`, {
            to: cleanerEmail,
            cleanerName,
            otherEmployeeName,
            leaveType,
            startDate,
            endDate,
            startTime,  // ADD
            endTime,
            type, // "assigned" or "removed"
            culture: localStorage.getItem("culture") || "nl",
            customerId: localStorage.getItem("customerId"),
            userId: localStorage.getItem("UserId"),
            organizationName: process.env.REACT_APP_ORGANIZATION_NAME
        }, {
            headers: { Authorization: process.env.REACT_APP_BasicAuthSecret }
        });
    } catch (err) {
        console.error("Error sending leave reassign email", err);
    }
};

export const sendRescheduleEmailToCleaner = async (cleanerEmail, cleanerName, orderInfo, showFrequency = true) => {
  try {
    const customerId = localStorage.getItem("customerId");
    await axios.post(`${process.env.REACT_APP_API_URL}/emailRoute/sendCleanerRescheduleEmail`, {
      to: cleanerEmail,
      cleanerName: cleanerName,
      culture: localStorage.getItem("culture") || "nl",
      orderInfo: orderInfo,
      customerId: customerId,
      userId: localStorage.getItem("UserId"),
      organizationName: process.env.REACT_APP_ORGANIZATION_NAME,
      showFrequency: showFrequency
    }, {
      headers: { Authorization: process.env.REACT_APP_BasicAuthSecret }
    });
  } catch (err) {
    console.error("Error sending reschedule email to cleaner", err);
  }
};

export const sendMultiTaskUnassignmentEmail = async (cleanerEmail,cleanerName,orderInfo) => {
    try {
        await axios.post(`${process.env.REACT_APP_API_URL}/emailRoute/sendMultiTaskUnassignmentEmail`, {
            to: cleanerEmail,
            cleanerName,
            orderInfo,
            culture: localStorage.getItem("culture") || "nl",
            customerId: localStorage.getItem("customerId"),
            userId: localStorage.getItem("UserId"),
            organizationName: process.env.REACT_APP_ORGANIZATION_NAME
        }, {
            headers: { Authorization: process.env.REACT_APP_BasicAuthSecret }
        });
    } catch (err) {
        console.error("Error sending multi-task unassignment email", err);
    }
};

export const getStatusColorClassesForTile = (status) => {
  const normalizedStatus = String(status || "").toLowerCase();

  switch (normalizedStatus) {
    case "0":
    case "planned":
      return { bg: "bg-primary-subtle" };

    case "1":
    case "inprogress":
      return { bg: "bg-info-subtle" };

    case "2":
    case "jobcomplete":
      return { bg: "bg-success-subtle" };

    case "3":
    case "unabletoaccesslocation":
      return { bg: "bg-warning-subtle" };

    case "4":
    case "customernotavailable":
      return { bg: "bg-warning-subtle" };

    case "5":
    case "equipmentissue":
      return { bg: "bg-warning-subtle" };

    case "6":
    case "cancelledbycustomer":
      return { bg: "bg-danger-subtle" };

    case "7":
    case "incomplete":
      return { bg: "bg-warning-subtle" };

    default:
      return { bg: "bg-light" };
  }
};

export const renderTaskStatusBadge = (status, t) => {
  let normalizedStatus = "";

  if (!isNaN(status) && status !== null && status !== "") {
    switch (Number(status)) {
      case 0: normalizedStatus = "planned"; break;
      case 1: normalizedStatus = "inprogress"; break;
      case 2: normalizedStatus = "jobcomplete"; break;
      case 3: normalizedStatus = "unabletoaccesslocation"; break;
      case 4: normalizedStatus = "customernotavailable"; break;
      case 5: normalizedStatus = "equipmentissue"; break;
      case 6: normalizedStatus = "cancelledbycustomer"; break;
      case 7: normalizedStatus = "incomplete"; break;
      default: normalizedStatus = ""; break;
    }
  } else {
    normalizedStatus = (status || "").toString().replace(/\s+/g, "").toLowerCase();
  }

  let variant;
  switch (normalizedStatus) {
    case "planned": variant = "primary"; break;
    case "inprogress": variant = "info"; break;
    case "jobcomplete": variant = "success"; break;
    case "unabletoaccesslocation":
    case "customernotavailable":
    case "equipmentissue":
      variant = "warning";
      break;
    case "cancelledbycustomer": variant = "danger"; break;
    case "incomplete": variant = "warning"; break;
    default: variant = "info"; break;
  }

  const translatedText = t?.(`orderDetailStatus.${normalizedStatus}`) || status;

  return (
    <Badge pill bg={variant} className="me-2">
      {translatedText}
    </Badge>
  );
};

export const getProposalStatusBadge = (status, t, fullWidth = false) => {
  let text = t("unknownStatus");
  let bg = "secondary";
  let icon = "question-circle";

  switch (status) {
    case "0": //status Open
      text = t("open");
      bg = "success";
      icon = "stream";
      break;
    case "1": //status agreed
      text = t("accepted");
      bg = "primary";
      icon = "check";
      break;
    case "2": //status not agreed
      text = t("notAgreed");
      bg = "danger";
      icon = "ban";
      break;
    case "3": //status proposal sent
      text = t("proposalSent");
      bg = "info";
      icon = "paper-plane";
      break;
    default:
      text = t("unknownStatus");
      bg = "secondary";
      icon = "question-circle";
      break;
  }

  return (
    <SubtleBadge
      pill
      bg={bg}
      className={
        fullWidth
          ? "w-100 d-flex justify-content-center align-items-center mb-1"
          : "d-inline-flex align-items-center px-2 mb-1"
      }
    >
      <span className="data-font-size">{text}</span>
      <FontAwesomeIcon
        icon={icon}
        transform="shrink-2"
        className="ms-1"
      />
    </SubtleBadge>
  );
};

export const portalStatusBadge = (portalStatus, t) => {
  const config = {
    Invited: { key: "portalInvited", variant: "warning" },
    Active: { key: "portalActive", variant: "success" },
    Disabled: { key: "portalDisabled", variant: "danger" },
  }[portalStatus];

  if (!config) {
    return <p className="fw-semi-bold mb-1 data-font-size data-font-colour text-wrap">--</p>;
  }

  return (
    <SubtleBadge pill bg={config.variant} className="d-inline-flex align-items-center px-2 mb-1">
      <p className="mb-0 data-font-size text-wrap">{t(config.key)}</p>
    </SubtleBadge>
  );
};

export const fetchTemplateSections = async (
  customerId,
  templateId,
  workType,
  setTemplateConfig,
  setSectionMap,
  setValues,
  proposalDetailsData,
  proposalId,
  proposalVersionId,
  isAdminView,
  currencySymbol
) => {
  const lang = localStorage.getItem("culture") || "nl";

  if (!customerId || !workType) {
    console.warn("Missing required parameters:", { customerId, workType });
    return;
  }

  try {
    let data = [];
    let templateSectionMap = {};
    let isEditMode = !isAdminView && Boolean(proposalId && proposalDetailsData);
    let usingSavedSections = false;

    if (proposalVersionId) {
      try {
        const [res, templateRes] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_API_URL}/proposalDetailsTemplateRoute/getProposalTemplate/version/${proposalVersionId}`,
            { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
          ),
          axios.get(
            `${process.env.REACT_APP_API_URL}/proposalTemplateSectionsRoute/byTemplateId/${customerId}/${templateId}?lang=${lang}`,
            { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
          ),
        ]);

        const savedSections = Array.isArray(res.data) ? res.data : [];

        if (savedSections.length > 0) {
          usingSavedSections = true;
          data = savedSections;

          const templateSections = templateRes.data?.Sections || [];
          templateSections.forEach((ts) => {
            templateSectionMap[ts.SectionId] = ts.TemplateSection;
          });
        } else {
          data = templateRes.data?.Sections || [];
        }
      } catch (err) {
        console.warn("Could not load saved sections, falling back to defaults", err);
      }
    }

    if (!usingSavedSections && !data.length) {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/proposalTemplateSectionsRoute/byTemplateId/${customerId}/${templateId}?lang=${lang}`,
        { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
      );
      data = res.data?.Sections || [];
    }

    if (!data.length) {
      console.error(
        `No template sections found for CustomerId=${customerId}, WorkType=${workType}, ProposalId=${proposalId}`
      );
      return;
    }

    if (usingSavedSections) {
      data = data.sort((a, b) => (a.SectionOrder || 0) - (b.SectionOrder || 0));
    }

    const firstItem = data[0];
    const config = {
      templateId: firstItem?.TemplateId || null,
      sections: usingSavedSections
        ? data.map((s) => templateSectionMap[s.SectionId]?.Key)
        : data.map((s) => s.TemplateSection?.Key),
    };

    const sectionsMap = {};
    const initialValues = {};

    const proposalDetailsNormalized = {};
    Object.entries(proposalDetailsData || {}).forEach(([k, v]) => {
      if (typeof k === "string") proposalDetailsNormalized[k.toLowerCase()] = v;
    });

    if (usingSavedSections) {
      // Render saved content from the existing version (v1 edit flow)
      data.forEach((s) => {
        const section = templateSectionMap[s.SectionId];
        if (!section) return;

        const key = section.Key;
        const proposalContent = s.DefaultContent || "";
        const defaultContent = section.DefaultContent || "";

        sectionsMap[key] = {
          key,
          type: section.Type || "editable",
          label_key: section.LabelKey || null,
          source: section.Source || null,
          defaultContent,
          proposalContent,
          languageCode: s.LanguageCode || lang,
          sectionId: s.SectionId,
        };

        if (section.Type === "editable") {
          initialValues[key] = proposalContent || defaultContent || "";
        }
      });
    } else {
      // Render fresh default sections — new proposal OR new version with no saved content
      data.forEach((s) => {
        const section = s.TemplateSection || s;
        const key = section.Key;
        const defaultContent = s.DefaultContent || "";
        // For a new version, don't carry over proposalDetailsData content from v1
        const proposalContent = "";

        sectionsMap[key] = {
          key,
          type: section.Type || "editable",
          label_key: section.LabelKey || null,
          source: section.Source || null,
          defaultContent,
          proposalContent,
          languageCode: s.LanguageCode || lang,
          sectionId: s.SectionId,
        };

        if (section.Type === "editable") {
          initialValues[key] = defaultContent || "";
        }
      });
    }

    setTemplateConfig(config);
    setSectionMap(sectionsMap);
    setValues(initialValues);
  } catch (error) {
    console.error("Error fetching template sections:", error);
  }
};

export const fetchTemplatesByCustomer = async (lang) => {
  try {
    const customerId = localStorage.getItem("customerId");
    const language = lang || localStorage.getItem("culture") || "nl";

    if (!customerId) return [];

    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/proposalTemplateSectionsRoute/proposalTemplates/${customerId}/${language}`,
      {
        headers: {
          Authorization: process.env.REACT_APP_BasicAuthSecret,
        },
      }
    );

    return res.data || [];
  } catch (error) {
    console.error("Error fetching templates with language:", error);
    return [];
  }
};

// Frequency → Bootstrap subtle pill color mapping
export const getFrequencyPillColor = (frequency) => {
  const normalizedFrequency = String(frequency || "").toLowerCase();

  switch (normalizedFrequency) {
    case "one time":
    case "onetime":
      return "secondary";

    case "daily":
      return "info";

    case "weekly":
      return "warning";

    case "monthly":
      return "success";

    default:
      return "primary";
  }
};

export const formatCreatedBy = (value) => {
  const SYSTEM_USER_ID = process.env.REACT_APP_SYSTEM_USER_ID;
  if (!value) return "--";
  if (SYSTEM_USER_ID && value.toLowerCase() === SYSTEM_USER_ID.toLowerCase()) return "System";
  return value;
};

// Remove only ONE order detail
export const deleteCleanerByOrderDetailId = async (orderDetailId, performedBy = null) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_API_URL}/orderRoute/deleteOrderDetail/${orderDetailId}`,
    {
      data: { performedBy },
      headers: {
        Authorization: process.env.REACT_APP_BasicAuthSecret
      }
    }
  );
  clearEmployeeAvailabilityCache();
  return response;
};

// Remove ALL order details for an employee on a given day
export const deleteAllCleanerOrderDetailsForDay = async (employeeId, date, customerId, locationId, performedBy = null) => {
  const res = await axios.delete(
    `${process.env.REACT_APP_API_URL}/orderRoute/deleteOrderDetailsByEmployeeAndDate`,
    {
      data: { employeeId, date, customerId, locationId, performedBy },
      headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
    }
  );
  clearEmployeeAvailabilityCache();
  return res.data.deletedCount;
};

export const CleanerDeleteModal = ({
  show,
  onClose,
  onRemoveThis,
  onRemoveAll,
  t
}) => {
  return (
    <Modal show={show} onHide={onClose} backdrop="static" contentClassName="border">
      <Modal.Header>
        <Modal.Title>{t("confirmation")}</Modal.Title>
        <FalconCloseButton onClick={onClose} />
      </Modal.Header>

      <Modal.Body>
        {t("confirmRemoveCleaner")}
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="falcon-default"
          size="sm"
          onClick={onClose}
        >
          {t("cancel")}
        </Button>

        <Button
          variant="danger"
          size="sm"
          onClick={onRemoveThis}
        >
          {t("removeThis")}
        </Button>

        <Button
          variant="danger"
          size="sm"
          onClick={onRemoveAll}
        >
          {t("removeAll")}
        </Button>
      </Modal.Footer>

    </Modal>
  );
};

export const validateCustomerEmailConfig = async (userId) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/userRoute/getUserById/${userId}`,
    {
      headers: {
        Authorization: process.env.REACT_APP_BasicAuthSecret
      }
    }
  );

  const user = response.data;

  const isCustomer = user?.IsCustomer === true;

  const hasEmailConfig =
    user?.SenderEmail &&
    user?.SmtpServer &&
    user?.PortNumber &&
    user?.SenderEmailPassword;

  if (isCustomer && !hasEmailConfig) {
    return {
      allowed: false,
      reason: "EMAIL_CONFIG_REQUIRED"
    };
  }

  return { allowed: true };
};

export const EmailConfigRequiredModal = ({
  show,
  onClose,
  t,
  type = "email", // "email" | "signature" | "both"
}) => {
  if (typeof t !== "function") return null;

  const navigate = useNavigate();

  const getModalContent = () => {
    switch (type) {
      case "signature":
        return {
          icon: "pen-nib",
          title: t("signatureRequired"),
          description: t("signatureRequiredDescription"),
          primaryAction: "signature",
          primaryLabel: t("addSignature"),
        };

      case "both":
        return {
          icon: "exclamation-circle",
          title: t("signatureAndEmailRequired"),
          description: t("signatureAndEmailRequiredDescription"),
          primaryAction: "email",
          primaryLabel: t("configureEmail"),
        };

      default: // "email"
        return {
          icon: "envelope",
          title: t("emailConfigurationRequired"),
          description: t("emailConfigurationRequiredDescription"),
          primaryAction: "email",
          primaryLabel: t("configureEmail"),
        };
    }
  };

  const modalContent = getModalContent();

  return (
    <>
      {/* Custom white overlay */}
      {show && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(255, 255, 255, 0.65)",
            zIndex: 1054, // just below modal
          }}
        />
      )}

      <Modal
        show={show}
        onHide={onClose}
        centered
        size="md"
        backdrop={false}      //  disable Bootstrap backdrop
        keyboard={false}
        style={{ zIndex: 1055 }}
        contentClassName="border-0 shadow"
      >
        <Modal.Body className="text-center p-4">
          {/* Icon */}
          <div className="mb-3 text-primary">
            <FontAwesomeIcon icon={modalContent.icon} size="2x" />
          </div>

          {/* Title */}
          <h5 className="mb-2 fw-semi-bold">
            {modalContent.title}
          </h5>

          {/* Description */}
          <p className="text-muted mb-4">
            {modalContent.description}
          </p>

          {/* Actions */}
          <div className="d-flex justify-content-center gap-3">
            {modalContent.primaryAction && (
              <Button
                variant="primary"
                className="px-4"
                onClick={() => {
                  onClose();
                  navigate("/profile", {
                    state: {
                      openEmailConfig: modalContent.primaryAction === "email",
                      openSignature: modalContent.primaryAction === "signature",
                    },
                  });
                }}
              >
                {modalContent.primaryLabel}
              </Button>
            )}

            <Button
              variant="outline-secondary"
              className="px-4"
              onClick={onClose}
            >
              {t("cancel")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

let socketInstance = null; 
export const getSocket = () => {
  const customerId = localStorage.getItem('customerId');
  const token = localStorage.getItem('token') || localStorage.getItem('Token');

  if (!socketInstance && customerId) {
    if (!token || token === 'undefined' || token === 'null') {
      console.warn('[Socket] Connection skipped: Missing user token in localStorage. Please log out and log back in.');
      return null;
    }

    const rawUrl = process.env.REACT_APP_API_URL;
    const socketUrl = new URL(rawUrl).origin;

    socketInstance = io(socketUrl, {
      auth: { token },
      transports: ['websocket'],
    });

    socketInstance.on('connect', () => {
      console.log('[WS] Connected, socket id:', socketInstance.id);
      const currentCustomerId = localStorage.getItem('customerId');
      if (currentCustomerId) socketInstance.emit('join:customer', currentCustomerId);
      const userId = localStorage.getItem('UserId');
      if (userId) socketInstance.emit('join:user', userId);
    });

    socketInstance.on('disconnect', () => {
      console.warn('[Socket] Disconnected');
    });

    socketInstance.on('connect_error', (err) => {
      console.error('[Socket] Connection error:', err.message);
    });
  } else if (socketInstance && customerId && !socketInstance.active) {
    if (!token || token === 'undefined' || token === 'null') {
      console.warn('[Socket] Reconnect skipped: Missing user token in localStorage.');
      return socketInstance;
    }
    socketInstance.auth = {
      token,
    };
    socketInstance.connect();
  }

  return socketInstance;
};

export const disconnectSocket = () => {
  if (socketInstance) socketInstance.disconnect();
};

export const dispatchBatchNotification = async ({ customerId, eventKey, entries, isRemoval = false }) => {
  if (!entries.length) return;
  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/notificationSettingsRoute/dispatch-batch`,
      {
        CustomerId: customerId,
        EventKey: eventKey,
        IsRemoval: isRemoval,
        Entries: entries.map(e => ({ Cleaner: e.cleaner, Data: e.data })),
      },
      { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
    );
  } catch (err) {
    console.error(`Batch dispatch failed for event ${eventKey}`, err);
  }
};

export const fetchFrequencyLabel = async (proposalId, proposalTaskId, t) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/proposalRoute/${proposalId}/tasks`,
      { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
    );
    const matchedTask = (res.data || []).find(pt => pt.ProposalTaskId === proposalTaskId);
    if (!matchedTask) return "";
    const freq = matchedTask.Frequency || "";
    const repeatEvery = matchedTask.RepeatEvery || "";
    const freqLower = freq.toLowerCase();
    return freq === "OneTime" ? t("onetime") : `${repeatEvery}x ${t(freqLower)}`;
  } catch (err) {
    console.error("fetchFrequencyLabel failed:", err);
    return "";
  }
};

export const buildTaskNotificationEntry = ({
  cleaner,          
  taskName,
  clientName,
  location,
  date,               
  startTime,      
  endTime,    
  frequency = "",
  culture,
  organizationName,
  userId,         
  sourceId,
  sourceType = "order",
  isActionRequired = false,
  inAppMessageCleanerKey,
  inAppMessageCleanerParams = {},
  inAppManagerSuffixKey,
  inAppManagerSuffixParams = {},
  whatsappTemplateName,
  whatsappParameters,
  t,
}) => ({
  cleaner,
  data: {
    orderInfo: {
      clientName,
      location,
      startDate: date,
      endDate: date,
      tasks: [{ taskName, startTime, endTime, frequency }],
    },
    culture,
    organizationName,
    userId,
    raisedFrom: userId,
    isActionRequired,
    sourceId,
    sourceType,
    sourceDate: date,
    inAppMessageCleaner: inAppMessageCleanerKey ? t(inAppMessageCleanerKey, inAppMessageCleanerParams) : undefined,
    inAppManagerSuffix: inAppManagerSuffixKey ? t(inAppManagerSuffixKey, inAppManagerSuffixParams) : undefined,
    ...(whatsappTemplateName ? { whatsappTemplateName, whatsappParameters } : {}),
  }
});

export const notifyLeaveDecision = async ({ unavailabilityId, updatedRecord, newStatus, note, adminId, customerId, t }) => {
  const getTranslatedShortMonth = (date) => t(`shortMonths.${moment(date).format("MMMM").toLowerCase()}`);
  const formatTranslatedDate = (date) => `${moment(date).format("DD")} ${getTranslatedShortMonth(date)} ${moment(date).format("YYYY")}`;

  const formatLocalTime = (dateStr, timeStr) => {
    if (!dateStr || !timeStr) return "";
    const time = moment.utc(timeStr).format("HH:mm:ss");
    const combined = moment.utc(`${moment.utc(dateStr).format("YYYY-MM-DD")}T${time}`);
    return combined.local().format("HH:mm");
  };

  const calculateDuration = (start, end, startTime, endTime) => {
    if (startTime && endTime) {
      const s = moment.utc(startTime);
      const e = moment.utc(endTime);
      const diffHours = e.diff(s, "minutes") / 60;
      if (diffHours > 0 && diffHours < 8) {
        const hrs = Math.floor(diffHours);
        const mins = Math.round((diffHours - hrs) * 60);
        return mins > 0 ? `${hrs}${t("hours")} ${mins}${t("minutes")}` : `${hrs}${t("hours")}`;
      }
    }
    const diffDays = Math.abs(new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24) + 1;
    return t("day", { count: diffDays });
  };

  const userRes = await axios.post(
    `${process.env.REACT_APP_API_URL}/userRoute/users/byIds`,
    { userIds: [updatedRecord.UserId] },
    { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
  );
  const employee = userRes.data?.[0];
  if (!employee) return;

  const entry = {
    cleaner: { userId: updatedRecord.UserId, name: employee.Name, email: employee.Emailaddress, phone: employee.PhoneNumber },
    data: {
      employeeName: employee.Name,
      status: newStatus,
      adminNote: note || null,
      culture: localStorage.getItem("culture") || "nl",
      userId: adminId,
      raisedFrom: adminId,
      unavailabilityId,
      startDate: formatTranslatedDate(updatedRecord.StartDate),
      endDate: formatTranslatedDate(updatedRecord.EndDate),
      startTime: updatedRecord.StartTime ? formatLocalTime(updatedRecord.StartDate, updatedRecord.StartTime) : "",
      endTime: updatedRecord.EndTime ? formatLocalTime(updatedRecord.EndDate, updatedRecord.EndTime) : "",
      totalWorkingDays: calculateDuration(updatedRecord.StartDate, updatedRecord.EndDate, updatedRecord.StartTime, updatedRecord.EndTime),
      isActionRequired: false,
      sourceId: unavailabilityId,
      sourceType: "absence",
      sourceDate: null,
      inAppMessageCleaner: t("in-AppNotifications.leaveDecisionMessage", {
        status: t(newStatus),
        fromDate: moment(updatedRecord.StartDate).format("DD-MM-YYYY"),
        toDate: moment(updatedRecord.EndDate).format("DD-MM-YYYY"),
      }),
     
    }
  };

  await dispatchBatchNotification({ customerId, eventKey: "VACATION_DECISION", entries: [entry] });
};

export const notifyLeaveRequested = async ({ unavailabilityId, employeeId, employeeName, requestType, startDate, endDate, startTime, endTime, employeeNote, totalWorkingDays, requestStatus, isResubmission = false, customerId, t }) => {
  const entry = {
    cleaner: { userId: employeeId },
    data: {
      employeeId,
      employeeFullName: employeeName,
      requestType,
      requestStatus,
      startDate,
      endDate,
      startTime,
      endTime,
      employeeNote,
      totalWorkingDays,
      culture: localStorage.getItem("culture") || "nl",
      userId: employeeId,
      raisedFrom: employeeId,
      isActionRequired: requestType?.toLowerCase() !== "sickness",
      sourceId: unavailabilityId,
      sourceType: "absence",
      sourceDate: null,
      inAppManagerSuffix: t(
        isResubmission ? "in-AppNotifications.leaveResubmittedManagerSuffix" : "in-AppNotifications.leaveRequestedManagerSuffix",
        {
          requestType: t(requestType?.toLowerCase()),
          startDate,
          endDate,
        }
      ),
    }
  };

  await dispatchBatchNotification({ customerId, eventKey: "LEAVE_REQUESTED", entries: [entry] });
};

export const notifyLeaveReassigned = async ({ customerId, leaveType, startDate, endDate, startTime, endTime, isSameEmployee, adminName, oldEmployee, newEmployee, t }) => {
  const culture = localStorage.getItem("culture") || "nl";
  const userId = localStorage.getItem("UserId");
  const organizationName = process.env.REACT_APP_ORGANIZATION_NAME;
  const dateLabel = startDate === endDate ? startDate : `${startDate} – ${endDate}`;

  if (isSameEmployee) {
    const entry = {
      cleaner: oldEmployee,
      data: {
        changeType: "dateChanged",
        leaveType, startDate, endDate, startTime, endTime,
        culture, userId, raisedFrom: userId, organizationName, customerId,
        isActionRequired: false,
        sourceId: null,
        sourceType: "absence",
        sourceDate: null,
        skipManagerNotification: true, // date-only change — not scoped for manager notification
        inAppMessageCleaner: t("in-AppNotifications.leaveDateChangedMessage", { leaveType, newDate: dateLabel }),
      }
    };
    await dispatchBatchNotification({ customerId, eventKey: "LEAVE_REASSIGNED", entries: [entry] });
    return;
  }

  const entries = [
    {
      cleaner: oldEmployee,
      data: {
        changeType: "removed",
        otherEmployeeName: newEmployee.name,
        leaveType, startDate, endDate, startTime, endTime,
        culture, userId, raisedFrom: userId, organizationName, customerId,
        isActionRequired: false,
        sourceId: null,
        sourceType: "absence",
        sourceDate: null,
        skipManagerNotification: true, 
        inAppMessageCleaner: t("in-AppNotifications.leaveRemovedMessage", { leaveType, date: dateLabel, newEmployeeName: newEmployee.name, adminName }),
      }
    },
        {
      cleaner: newEmployee,
      data: {
        changeType: "assigned",
        otherEmployeeName: oldEmployee.name,
        employeeFullName: newEmployee.name,
        newEmployeeUserId: newEmployee.userId,
        totalWorkingDays: startDate === endDate ? 1 : moment(endDate).diff(moment(startDate), "days") + 1,
        leaveType, startDate, endDate, startTime, endTime,
        culture, userId, raisedFrom: userId, organizationName, customerId,
        isActionRequired: false,
        sourceId: null,
        sourceType: "absence",
        sourceDate: null,
        inAppMessageCleaner: t("in-AppNotifications.leaveAssignedMessage", { leaveType, date: dateLabel, oldEmployeeName: oldEmployee.name, adminName }),
        inAppManagerSuffix: t("in-AppNotifications.leaveAssignedManagerSuffix", { leaveType, date: dateLabel }),
      }
    }
  ];
  await dispatchBatchNotification({ customerId, eventKey: "LEAVE_REASSIGNED", entries });
};

export const buildConflictMapFromUnavailability = (unavailability = []) => {
  const conflictMap = {};

  unavailability.forEach((leave) => {
    const statusLower = (leave.Status || leave.status || "").toLowerCase();
    if (statusLower === "rejected") return;

    const employeeId = leave.UserId;
    if (!employeeId) return;

    let cursor = moment(leave.StartDate || leave.startDate);
    const leaveEnd = moment(leave.EndDate || leave.endDate);

    while (cursor.isSameOrBefore(leaveEnd, "day")) {
      const dateStr = cursor.format("YYYY-MM-DD");
      if (!conflictMap[employeeId]) {
        conflictMap[employeeId] = { dates: new Set(), leaveData: leave };
      }
      conflictMap[employeeId].dates.add(dateStr);
      cursor.add(1, "day");
    }
  });

  return conflictMap;
};

export const fetchLeaveConflictMap = async (customerId, startDate, endDate) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/userUnavailabilityRoute/unavailabilityByCustomerIdWithDate`,
      {
        params: {
          customerId,
          startDate: moment(startDate).format("YYYY-MM-DD"),
          endDate: moment(endDate).format("YYYY-MM-DD"),
        },
        headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
      }
    );

    const unavailability = res.data || [];
    return buildConflictMapFromUnavailability(unavailability);
  } catch (err) {
    console.error("Failed to fetch leave conflict map:", err);
    return {};
  }
};

export const checkEmployeeLeaveConflict = (conflictMap, employeeId, startDate, endDate = null) => {
  const entry = conflictMap?.[employeeId];
  if (!entry) return null;

  let cursor = moment(startDate);
  const end = moment(endDate || startDate);

  while (cursor.isSameOrBefore(end, "day")) {
    if (entry.dates.has(cursor.format("YYYY-MM-DD"))) {
      return entry.leaveData;
    }
    cursor.add(1, "day");
  }
  return null;
};

export const LeaveWarningModal = ({ show, leaveType, leaveStatus, employeeName, onConfirm, onCancel, t }) => (
  <Modal show={show} onHide={onCancel}>
    <Modal.Header closeButton>
      <Modal.Title>
        <FontAwesomeIcon icon="exclamation-triangle" className="text-warning me-2" />
        {t("leaveWarningTitle")}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="mb-0">
        {t(
          leaveType === "sickness"
            ? "leaveWarningMessageSick"
            : leaveStatus?.toLowerCase() === "pending"
              ? "leaveWarningMessagePending"
              : "leaveWarningMessageVacation",
          { employeeName }
        )}
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="falcon-default" size="sm" onClick={onCancel}>{t("cancel")}</Button>
      <Button variant="primary" size="sm" onClick={onConfirm}>{t("confirm")}</Button>
    </Modal.Footer>
  </Modal>
);

export const findEmployeeTimeConflict = (slots = [], employeeId, newStart, newEnd, excludeId = null) => {
  if (!employeeId || !newStart || !newEnd) return null;

  const newStartM = moment(newStart);
  const newEndM = moment(newEnd);

  return (
    slots.find((slot) => {
      if (!slot) return false;
      if (excludeId && slot.id === excludeId) return false;
      if (slot.employeeId !== employeeId) return false;

      const slotStart = moment(slot.start);
      const slotEnd = moment(slot.end);

      return newStartM.isBefore(slotEnd) && slotStart.isBefore(newEndM);
    }) || null
  );
};

export const fetchEmployeeScheduledSlots = async (employeeId, customerId, startDate, endDate) => {
  const res = await axios.get(
    `${process.env.REACT_APP_API_URL}/orderRoute/byUserAndDateRange`,
    {
      params: {
        userId: employeeId,
        customerId,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
      },
      headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
    }
  );

  return res.data?.data?.orderDetails || [];
};

export const combineDateAndTimeOfDay = (dateStr, timeStr) => {
  if (!dateStr || !timeStr) return null;
  const timeOfDay = moment.utc(timeStr).format("HH:mm:ss");
  const combined = moment.utc(`${moment.utc(dateStr).format("YYYY-MM-DD")}T${timeOfDay}`);
  return combined.isValid() ? combined.local() : null;
};

export const TaskConflictModal = ({
  show,
  employeeName,
  conflictTaskName,
  conflictClientName,   
  conflictStart,
  conflictEnd,
  onConfirm,
  onCancel,
  t,
}) => (
  <Modal show={show} onHide={onCancel}>
    <Modal.Header closeButton>
      <Modal.Title>
        <FontAwesomeIcon icon="exclamation-triangle" className="text-warning me-2" />
        {t("taskConflictTitle")}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="mb-0">
        {t("taskConflictMessage", {
          employeeName,
          clientName: conflictClientName || t("anotherClient"),
          startTime: conflictStart ? moment(conflictStart).format("HH:mm") : "",
          endTime: conflictEnd ? moment(conflictEnd).format("HH:mm") : "",
        })}
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="falcon-default" size="sm" onClick={onCancel}>{t("cancel")}</Button>
      <Button variant="primary" size="sm" onClick={onConfirm}>{t("confirm")}</Button>
    </Modal.Footer>
  </Modal>
);

export const PlanningConflictModal = ({ show, employeeName, conflictType, onConfirm, onCancel, t }) => {
  const messageKey =
    conflictType === "leave"
      ? "leaveWarningMessageleave"
      : conflictType === "taskConflict"
      ? "taskConflictsMessage"
      : "leaveAndConflictStatement";

  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FontAwesomeIcon icon="exclamation-triangle" className="text-warning me-2" />
          {t("planningConflictTitle")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2">{t(messageKey, { employeeName })}</p>
        <p className="mb-0">{t("confirmAssignPrompt", { employeeName })}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" size="sm" onClick={onCancel}>{t("cancel")}</Button>
        <Button variant="primary" size="sm" onClick={onConfirm}>{t("confirm")}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export const SchedulingIssuesModal = ({ show, issues = [], onConfirm, onCancel, t }) => {
  const grouped = [];
  const groupIndexByEmployee = {};

  issues.forEach((issue) => {
    const groupKey = issue.employeeId || issue.employeeName || issue.toEmployee;
    if (!groupKey) return; // skip issues we can't attribute to an employee

    const employeeName = issue.employeeName || issue.toEmployee || "";

    if (groupIndexByEmployee[groupKey] === undefined) {
      groupIndexByEmployee[groupKey] = grouped.length;
      grouped.push({ employeeName, hasLeave: false, hasTaskConflict: false, hasPastDateAssign: false });
    } else if (employeeName && !grouped[groupIndexByEmployee[groupKey]].employeeName) {
      grouped[groupIndexByEmployee[groupKey]].employeeName = employeeName;
    }

    const group = grouped[groupIndexByEmployee[groupKey]];
    if (issue.type === "leave") group.hasLeave = true;
    if (issue.type === "taskConflict") group.hasTaskConflict = true;
    if (issue.type === "pastDateAssign") group.hasPastDateAssign = true;
  });

  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FontAwesomeIcon icon="exclamation-triangle" className="text-warning me-2" />
          {t("planningConflictTitle")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          {grouped.map((group, idx) => {
            const { hasLeave, hasTaskConflict, hasPastDateAssign, employeeName } = group;

            let messageKey;
            if (hasLeave && hasTaskConflict && hasPastDateAssign) {
              messageKey = "leaveConflictAndPastDateAssignStatement";
            } else if (hasLeave && hasPastDateAssign) {
              messageKey = "leaveAndPastDateAssignStatement";
            } else if (hasTaskConflict && hasPastDateAssign) {
              messageKey = "taskConflictAndPastDateAssignStatement";
            } else if (hasLeave && hasTaskConflict) {
              messageKey = "leaveAndConflictStatement";
            } else if (hasLeave) {
              messageKey = "leaveWarningMessageleave";
            } else if (hasTaskConflict) {
              messageKey = "taskConflictsMessage";
            } else if (hasPastDateAssign) {
              messageKey = "pastDateAssignStatement";
            }

            return (
              <div key={idx} className="mb-2">
                {messageKey && (
                  <p className="mb-1">{t(messageKey, { employeeName })}</p>
                )}
                <p className="mb-0">{t("confirmAssignPrompt", { employeeName })}</p>
              </div>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" size="sm" onClick={onCancel}>{t("cancel")}</Button>
        <Button variant="primary" size="sm" onClick={onConfirm}>{t("confirm")}</Button>
      </Modal.Footer>
    </Modal>
  );
};

// Entries live for 30 seconds and must be cleared after successful assignment mutations.
const employeeSlotsCache = new Map();
const EMPLOYEE_SLOTS_CACHE_TTL = 30000;

export const clearEmployeeAvailabilityCache = () => employeeSlotsCache.clear();

export const checkEmployeeAvailability = async ({
  employeeId,
  conflictMap = {},
  startDate,
  endDate,
  occurrenceDates,
  timeWindow,
  inFormSlots = [],
  customerId,
  excludeOrderDetailId = null,
  skipBackendFetch = false,
  backendSlots: preFetchedSlots = null,
  extraValidators = [],
}) => {
const leaveConflict = checkEmployeeLeaveConflict(
    conflictMap,
    employeeId,
    startDate,
    endDate || startDate
  );

  const leaveResult = leaveConflict
    ? {
        type: "leave",
        leaveType: (leaveConflict.Type || leaveConflict.type || "").toLowerCase(),
        leaveStatus: leaveConflict.Status || leaveConflict.status || "Pending",
        raw: leaveConflict,
      }
    : null;

  if (timeWindow?.startTimeOfDay && occurrenceDates?.length) {
    let backendSlots = preFetchedSlots || [];

    if (!skipBackendFetch && !preFetchedSlots && customerId) {
      try {
        const rangeStart = occurrenceDates[0];
        const rangeEnd = occurrenceDates[occurrenceDates.length - 1];
        const cacheKey = `${employeeId}:${moment(rangeStart).format("YYYY-MM-DD")}:${moment(rangeEnd).format("YYYY-MM-DD")}`;
        const cached = employeeSlotsCache.get(cacheKey);
        let slotsRequest = cached && Date.now() - cached.timestamp < EMPLOYEE_SLOTS_CACHE_TTL
          ? cached.value
          : null;
        if (!slotsRequest) {
          slotsRequest = fetchEmployeeScheduledSlots(employeeId, customerId, rangeStart, rangeEnd);
          employeeSlotsCache.set(cacheKey, { timestamp: Date.now(), value: slotsRequest });
          slotsRequest.catch(() => employeeSlotsCache.delete(cacheKey));
        }
        const rawSlots = await slotsRequest;
        backendSlots = rawSlots
          .filter((s) => s.OrderDetailId !== excludeOrderDetailId)
          .map((s) => ({
            id: s.OrderDetailId,
            employeeId,
            start: combineDateAndTimeOfDay(s.WeekStartDate, s.StartTime),
            end: combineDateAndTimeOfDay(s.WeekStartDate, s.EndTime),
            label: s.TaskName || "Task",
            clientName: s.ClientName || null,
          }))
          .filter((s) => s.start && s.end);
      } catch (err) {
        console.error("checkEmployeeAvailability: backend slot fetch failed", err);
      }
    }

    for (const occDate of occurrenceDates) {
      const newStart = moment(occDate).set({
        hour: timeWindow.startTimeOfDay.hour(),
        minute: timeWindow.startTimeOfDay.minute(),
        second: 0,
      });
      const newEnd = moment(occDate).set({
        hour: timeWindow.endTimeOfDay.hour(),
        minute: timeWindow.endTimeOfDay.minute(),
        second: 0,
      });
      const dateStr = occDate.format("YYYY-MM-DD");

      const backendSlotsThatDay = backendSlots.filter(
        (s) => moment(s.start).format("YYYY-MM-DD") === dateStr
      );
      let conflict = findEmployeeTimeConflict(backendSlotsThatDay, employeeId, newStart, newEnd, excludeOrderDetailId);

      if (!conflict && inFormSlots.length) {
        const dayKey = occDate.format("dddd").toLowerCase();
        const sameDaySlots = inFormSlots.filter(
          (s) => s.dayKey === dayKey || s.date === dateStr
        );
        conflict = findEmployeeTimeConflict(sameDaySlots, employeeId, newStart, newEnd, excludeOrderDetailId);
      }

      if (conflict) {
        const taskConflictResult = {
          type: "taskConflict",
          conflictTaskName: conflict.label,
          conflictClientName: conflict.clientName,
          conflictStart: conflict.start,
          conflictEnd: conflict.end,
          conflictDate: occDate,
          raw: conflict,
        };

        if (leaveResult) {
          return { type: "combined", issues: [leaveResult, taskConflictResult] };
        }

        return taskConflictResult;
      }
    }
  }

for (const validate of extraValidators) {
    const result = await validate({ employeeId, startDate, endDate, occurrenceDates, timeWindow, customerId });
    if (result) return result;
  }

  return leaveResult; 
};

const recommendationCache = new Map();
const RECOMMENDATION_CACHE_TTL = 30000;

export const fetchRecommendedEmployees = async (customerId, selectedEmployeeIds) => {
  const sortedIds = [...new Set(selectedEmployeeIds || [])].sort();
  const cacheKey = `${customerId}:${sortedIds.join(",")}`;
  const cached = recommendationCache.get(cacheKey);
  if (cached && Date.now() - cached.timestamp < RECOMMENDATION_CACHE_TTL) return cached.value;

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/userRoute/recommendedEmployees`,
      { customerId, selectedEmployeeIds },
      {
        headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
      }
    );

    const result = res.data?.data || res.data;
    const value = result?.hasSpecialityMatch ? result.employees || [] : null;
    recommendationCache.set(cacheKey, { timestamp: Date.now(), value });
    return value;
  } catch (err) {
    console.error("Failed to fetch recommended employees:", err);
    return null;
  }
};

export const sortEmployeesAscending = (fullList = []) => [...fullList].sort((a, b) =>
  (a.Name || "").localeCompare(b.Name || "")
);

export const partitionRecommendedEmployees = async (fullList = [], recommendedEmployees = [], availabilityCheckFn) => {
  const recommendations = new Map(
    (recommendedEmployees || []).map((item, index) => {
      const id = item?.UserId ?? item?.userId ?? item;
      return [String(id), item?.matchedSpecialityCount ?? item?.matchedSpecialtiesCount ?? (recommendedEmployees.length - index)];
    })
  );
  const candidates = fullList.filter((employee) => recommendations.has(String(employee.UserId)));
  const availabilityResults = availabilityCheckFn
    ? await Promise.all(candidates.map(async (employee) => ({
        employeeId: employee.UserId,
        result: await availabilityCheckFn(employee),
      })))
    : [];
  const availability = new Map(availabilityResults.map((item) => [
    String(item.employeeId),
    !item.result?.type,
  ]));

  const recommended = candidates
    .filter((employee) => availability.get(String(employee.UserId)) !== false)
    .sort((a, b) =>
      recommendations.get(String(b.UserId)) - recommendations.get(String(a.UserId)) ||
      (a.Name || "").localeCompare(b.Name || "")
    );
  const recommendedSet = new Set(recommended.map((employee) => String(employee.UserId)));
  const others = sortEmployeesAscending(fullList.filter((employee) => !recommendedSet.has(String(employee.UserId))));

  return { recommended, others };
};

export const getTranslatedSalutation = (relation, t) => {
  if (!relation) return "";

  if (relation.FirstName || relation.LastName) {
    const translatedSalutation = relation.Salutation
      ? t(relation.Salutation.toLowerCase())
      : "";

    return [translatedSalutation, relation.FirstName, relation.LastName]
      .filter(Boolean)
      .join(" ");
  }

  return relation.Contactperson || "";
};

const arrayBufferToBase64 = (buffer) => {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  }
  return btoa(binary);
};

export const registerRupeeFont = async (doc) => {
  const base = process.env.PUBLIC_URL || "";
  const buf = await fetch(`${base}/fonts/NotoSans-Regular.ttf`).then((r) => r.arrayBuffer());
  doc.addFileToVFS("NotoSans-Regular.ttf", arrayBufferToBase64(buf));
  doc.addFont("NotoSans-Regular.ttf", "NotoSans", "normal");
};

const isCurrencyCell = (data, currencyColumns) =>
  data.section === "body" && currencyColumns.includes(data.column.index);

const extractRupeeAmount = (cell) => {
  const txt = (cell.text || []).join("");
  return txt.startsWith("₹") ? txt.slice(1) : null;
};

const measureWithFont = (doc, font, text) => {
  doc.setFont(font, "normal");
  return doc.getTextWidth(text);
};

const drawWithFont = (doc, font, text, x, y) => {
  doc.setFont(font, "normal");
  doc.text(text, x, y, { baseline: "middle" });
};

const drawRupeeAmount = (doc, cell, amount) => {
  const { x, y, width, height } = cell;
  doc.setFontSize(cell.styles.fontSize);
  doc.setTextColor(...[].concat(cell.styles.textColor));

  const symbolWidth = measureWithFont(doc, "NotoSans", "₹");
  const amountWidth = measureWithFont(doc, "helvetica", amount);
  const startX = x + (width - (symbolWidth + amountWidth)) / 2;
  const midY = y + height / 2;

  drawWithFont(doc, "NotoSans", "₹", startX, midY);
  drawWithFont(doc, "helvetica", amount, startX + symbolWidth, midY);
};

export const getRupeeCellHooks = (doc, currencyColumns = []) => ({
  didParseCell: (data) => {
    if (!isCurrencyCell(data, currencyColumns)) return;
    const amount = extractRupeeAmount(data.cell);
    if (amount === null) return;
    data.cell.rupeeAmount = amount;
    data.cell.text = [""];
  },
  didDrawCell: (data) => {
    const amount = data.cell.rupeeAmount;
    if (data.section !== "body" || amount == null) return;
    drawRupeeAmount(doc, data.cell, amount);
  },
});

const NON_LATIN_RE = /[^\u0000-\u024F\u2000-\u206F\u20A0-\u20CF]/;

const COLOR_CONVERTERS = {
  object: (c) => (Array.isArray(c) ? `rgb(${c[0]},${c[1]},${c[2]})` : "#000"),
  number: (c) => `rgb(${c},${c},${c})`,
  string: (c) => c,
};
const DEFAULT_COLOR = () => "#000";

const pdfColorToCss = (colour) => (COLOR_CONVERTERS[typeof colour] || DEFAULT_COLOR)(colour);

const IMAGE_RENDER_SCALE = 4;
const LINE_HEIGHT_RATIO = 1.6;
const HORIZONTAL_PADDING_PX = 2;
const FONT_STACK = '"Noto Sans Devanagari","Nirmala UI","Mangal",sans-serif';

const textToImage = (text, fontSizePt, isBold, textColor) => {
  const fontSizePx = fontSizePt * IMAGE_RENDER_SCALE;
  const fontWeight = isBold ? 700 : 400;
  const fontDeclaration = `${fontWeight} ${fontSizePx}px ${FONT_STACK}`;

  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  context.font = fontDeclaration;

  const textWidthPx = Math.ceil(context.measureText(text).width);
  const canvasWidthPx = textWidthPx + HORIZONTAL_PADDING_PX * 2;
  const canvasHeightPx = Math.ceil(fontSizePx * LINE_HEIGHT_RATIO);

  canvas.width = canvasWidthPx;
  canvas.height = canvasHeightPx;
  context.font = fontDeclaration;
  context.textBaseline = "middle";
  context.fillStyle = textColor;
  context.fillText(text, HORIZONTAL_PADDING_PX, canvasHeightPx / 2);

  return {
    dataUrl: canvas.toDataURL("image/png"),
    wPt: canvasWidthPx / IMAGE_RENDER_SCALE,
    hPt: canvasHeightPx / IMAGE_RENDER_SCALE,
  };
};

const toText = (value) => String(value ?? "");
const hasNonLatin = (value) => NON_LATIN_RE.test(toText(value));

const drawAsText = (doc, value, x, y, fontSize) => {
  doc.setFontSize(fontSize);
  doc.text(value, x, y);
};

const drawAsImage = (doc, value, x, y, fontSize, bold) => {
  const img = textToImage(value, fontSize, bold, "#000");
  doc.addImage(img.dataUrl, "PNG", x, y - fontSize * 0.35 - img.hPt / 2, img.wPt, img.hPt);
};

const TEXT_DRAWERS = { true: drawAsImage, false: drawAsText };

export const drawPdfText = (doc, text, x, y, fontSize = 12, bold = false) =>
  TEXT_DRAWERS[hasNonLatin(text)](doc, toText(text), x, y, fontSize, bold);

export const getUnicodePdfHooks = (doc, baseHooks = {}) => ({
  didParseCell: (data) => {
    baseHooks.didParseCell?.(data);
    const raw = Array.isArray(data.cell.text) ? data.cell.text.join(" ") : String(data.cell.text ?? "");
    if (!NON_LATIN_RE.test(raw)) return;

    const fs = data.cell.styles.fontSize || 10;
    const bold = String(data.cell.styles.fontStyle || "").includes("bold");
    const img = textToImage(raw, fs, bold, pdfColorToCss(data.cell.styles.textColor));
    data.cell.unicodeImg = img;
   
    data.cell.text = ["x".repeat(Math.max(1, Math.ceil(img.wPt / (fs * 0.5))))];
  },
  willDrawCell: (data) => {
    baseHooks.willDrawCell?.(data);
    if (data.cell.unicodeImg) data.cell.text = [""];
  },
  didDrawCell: (data) => {
    baseHooks.didDrawCell?.(data);
    const img = data.cell.unicodeImg;
    if (!img) return;

    const pad = (side) => {
      try { return data.cell.padding(side); } catch { return 2; }
    };
    const maxW = data.cell.width - pad("left") - pad("right");
    let w = img.wPt;
    let h = img.hPt;
    if (w > maxW) { const r = maxW / w; w *= r; h *= r; }

    const align = data.cell.styles.halign;
    let x;
    if (align === "left") x = data.cell.x + pad("left");
    else if (align === "right") x = data.cell.x + data.cell.width - pad("right") - w;
    else x = data.cell.x + (data.cell.width - w) / 2;
    const y = data.cell.y + (data.cell.height - h) / 2;

    doc.addImage(img.dataUrl, "PNG", x, y, w, h);
  },
});